<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoguanxitupu'>
    <div v-if="isLoading===3" class="box">
      <div class="loadingBox text-danger">
        <i class='iconfont icon-jinggao'></i>
        <br>
        <br>
        <div>查询失败</div>
      </div>
    </div>
    <div v-if="isLoading===1" class="box">
      <div class="loadingBox">
        <i class='iconfont icon-jiazai xuanzhuan'></i>
        <br>
        <br>
        <div>读取中</div>
      </div>
    </div>
    <div v-if="isLoading===2" id="guanxitupuCanva"></div>
    <div class="lists textSelect">
      <ul>
        <li v-for="(app,index) in guanxiArr.series[0].data" :key="index" class="">
          <p class="content">{{app.name}}</p>
          {{app.id}}
        </li>
      </ul>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import { EventBus } from '@/util/eventBus';
import resultCommons from '@/util/resultcommons';

export default {
  name: 'commonClientinfoguanxitupu',
  props: ['token'],
  data() {
    return {
      isLoading: 1,
      myGuanxiChart: null,
      guanxiArr: {
        backgroundColor: 'rgb(255,255,255)',
        title: {
          text: '陈丽夫 · 关系图谱',
          subtext: '父级 - 红，子集 - 绿，孙级 - 黄',
          top: 'top',
          left: 'center',
        },
        tooltip: {},
        animationDuration: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            name: '数据编号',
            type: 'graph',
            layout: 'force',
            force: {
              repulsion: 700,
              edgeLength: 90,
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 8],
            symbolSize: 60,
            edgeLabel: {
              fontSize: 20,
            },
            data: [],
            links: [],
            categories: [
              { id: 0, name: 'A' },
              { id: 1, name: 'B' },
              { id: 2, name: 'C' },
              { id: 3, name: 'D' },
              { id: 4, name: 'E' },
              { id: 5, name: 'F' },
              { id: 6, name: 'G' },
              { id: 7, name: 'H' },
              { id: 8, name: 'I' },
            ],
            draggable: true,
            roam: true,
            label: {
              show: true,
            },
            lineStyle: {
              opacity: 0.5,
              width: 1.5,
              curveness: 0,
            },
            emphasis: {
              focus: 'adjacency',
              lineStyle: {
                width: 2,
              },
            },
          },
        ],
      },
    };
  },
  computed: {
  },
  methods: {
    // 跟进图表
    sizeGuanxiCanvaFun() {
      this.myGuanxiChart.resize();
      this.myGuanxiChart.setOption(this.guanxiArr, true);
    },
    apiCrmmap() {
      this.isLoading = 1;
      return resultCommons.apiCrmmap(this, { token: this.token }).then((ob) => {
        if (ob.state === 200) {
          console.log(ob);
          this.guanxiArr.series[0].data = ob.data.data;
          this.guanxiArr.series[0].links = ob.data.links;
          this.guanxiArr.title.text = `${ob.data.user} · 关系图谱`;
          this.isLoading = 2;
        } else {
          this.isLoading = 3;
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
  },
  created() {
  },
  mounted() {
    this.apiCrmmap().then((app) => {
      this.myGuanxiChart = window.echarts.init(document.getElementById('guanxitupuCanva'));
      this.myGuanxiChart.setOption(this.guanxiArr);
      window.addEventListener('resize', this.sizeGuanxiCanvaFun, { passive: false, useCapture: false });
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.sizeGuanxiCanvaFun);
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoguanxitupu{
  background: #FFFFFF;
  width: 50vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 1rem rgba(0, 0, 0, 0.15);
  position: relative;
  #guanxitupuCanva{
    height: 80%;
    width: 100%;
    flex: 1;
  }
  .lists{
    background:#FAFAFA;
    height: 100%;
    padding: 15px;
    border-left: 1px solid #EEEEEE;
    overflow-y: auto;
    ul{
      li{
        margin-bottom: 20px;
        border-bottom: 1px solid #EEEEEE;
        p{
          margin: 0;
        }
      }
    }
  }
  div.box{
    .duquzhongBox{
      text-align: center;
      margin-top: 40px;
      i{
        font-size: 40px;
      }
      div{
        margin-top: 20px;
      }
    }
    div.loadingBox{
      padding-bottom: 0;
      text-align: center;
      i{
        font-size: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/guanxitupu.vue